import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
const AttemptsBox = ({ color = '#fff', backgroundColor = '#327861', attemptsLeft, }) => {
    const { t } = useTranslation();
    return (_jsxs("div", { className: 'attempts-box', style: { backgroundColor, color }, children: [_jsx("span", { className: 'attempts-box-label', children: t('label.still') }), _jsx("span", { className: "attempts-box-value", children: attemptsLeft }), _jsx("span", { className: 'attempts-box-label', children: t(attemptsLeft > 1 ? 'label.attempts' : 'label.attempt') })] }));
};
export default AttemptsBox;
